import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {Link} from 'gatsby';

function Cuttingedge(props) {
    return (
        <div className="p-100 tekrevol_dark_bg lp_discuss startup_cta" style={{ backgroundColor: "#eb5627" }}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={10} xxl={10} className="m-auto text-center">
                            <h2>Tekrevol Just Happens To Make Great Apps</h2>
                        <Link to="tel:+8003629239"
                              className="border_btn" aria-label="TekRevol Contact">Want One For Your Brand?</Link>     
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Cuttingedge;